(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sanctuary-resources"] && !Shopify.designMode) return;
  try {
    
function setupSanctuaryResources(root) {
 root.querySelectorAll('[data-resource-directory]').forEach(directory=>{
  if(directory.dataset.ready)return;directory.dataset.ready='true';
  const input=directory.querySelector('[data-resource-search]');
  const buttons=[...directory.querySelectorAll('[data-filter]')];
  const cards=[...directory.querySelectorAll('[data-resource-card]')];
  let category='software';
  const update=()=>{let shown=0;const q=input.value.trim().toLowerCase();cards.forEach(card=>{card.hidden=!((category==='all'||card.dataset.category===category)&&card.textContent.toLowerCase().includes(q));if(!card.hidden)shown++;});buttons.forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.filter===category)));directory.querySelector('[data-resource-empty]').hidden=shown>0;};
  buttons.forEach(button=>button.addEventListener('click',()=>{category=button.dataset.filter;update();}));input.addEventListener('input',()=>{if(input.value.trim())category='all';update();});update();
 });
}
setupSanctuaryResources(document);
document.addEventListener('shopify:section:load',event=>setupSanctuaryResources(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sanctuary-video"] && !Shopify.designMode) return;
  try {
    
function startSanctuaryVideo(root) {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  root.querySelectorAll('.sc-hero-video').forEach(video => {
    video.muted = true;
    video.play().catch(() => {});
  });
}
startSanctuaryVideo(document);
document.addEventListener('shopify:section:load', event => startSanctuaryVideo(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wishwell-collection"] && !Shopify.designMode) return;
  try {
    
function setupWishWellExplorer(root) {
  root.querySelectorAll('[data-ww-explorer]').forEach(explorer => {
    if (explorer.dataset.ready) return;
    explorer.dataset.ready = 'true';
    const tabs = [...explorer.querySelectorAll('[role="tab"]')];
    const panels = [...explorer.querySelectorAll('[role="tabpanel"]')];
    const activate = (tab, focus) => {
      tabs.forEach(item => { const selected = item === tab; item.setAttribute('aria-selected', String(selected)); item.tabIndex = selected ? 0 : -1; });
      panels.forEach(panel => { panel.hidden = panel.id !== tab.getAttribute('aria-controls'); });
      if (focus) tab.focus();
    };
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activate(tab, false));
      tab.addEventListener('keydown', event => {
        let next;
        if (event.key === 'ArrowDown') next = (index + 1) % tabs.length;
        if (event.key === 'ArrowUp') next = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (next !== undefined) { event.preventDefault(); activate(tabs[next], true); }
      });
    });
  });
}
setupWishWellExplorer(document);
document.addEventListener('shopify:section:load', event => setupWishWellExplorer(event.target));

  } catch(e) { console.error(e); }
})();
})();
